module.exports = __webpack_public_path__ + "img/female-adult-hand.54e09c96.svg";